export function removeParameter(url, parameterName) {
    return url.replace(new RegExp(parameterName + "=\\w+"),"")
              .replace("?&","?")
              .replace("&&","&")
              .replace(/\?+$/, '')
              .replace(/&+$/, '');
}

export function addParameters(url, parameters) {
    return url + '?' + stringifyParameters(parameters);
}

export function stringifyParameters(parameters) {
    return Object.keys(parameters).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(parameters[k] !== null ? parameters[k] : '')
    }).join('&');
}
